/* eslint-disable eqeqeq */
import React, { useState, useEffect, useContext } from "react";
// Materila ui
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import TextField from "@material-ui/core/TextField";
import LockIcon from "@material-ui/icons/Lock";
import EmailIcon from "@material-ui/icons/Email";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
// Axios for Api
import axios from "axios";
// AppState
import DispatchContext from "../DispatchContext";
import StateContext from "../StateContext";

const styles = (theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function EmailValidate({ handleClose, open, setValidateStatus, setIsLoading }) {
  const classes = useStyles();
  const appDispatch = useContext(DispatchContext);
  const appState = useContext(StateContext);

  const [loading, setLoading] = useState(false);
  const [codeStatus, setCodeStatus] = useState(false);
  const [registerdEmail, setRegisterdEmail] = useState("");
  const [code, setCode] = useState("");
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });


  // // Handle Register Submit
  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    // response from recoveryCode component

    var result = await axios.post(`${process.env.REACT_APP_API_URL}validate/email`, {
      code: code,
    },
    {
      headers: {
        Authorization: `Bearer ${appState.token}`,
      },
    });

    if(result.data.success == false){
      setAlertMessage({
        open: true,
        message: result.data.message,
        alertSuccess: false,
      });
    }else if(result.data.success == true){
      handleClose()
      setValidateStatus(true)

    }

  };

  useEffect(() => {
    setLoading(false)
    setCode("")
  }, [handleClose])

  useEffect(() => {
    setTimeout(
      () => setAlertMessage({ open: false}),
      3000
    );
  }, [alertMessage.open]);

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>

      <Dialog
        aria-labelledby="customized-dialog-title"
        open={open}
        id="Login-Modal"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {/* Modal title */}
        </DialogTitle>

        <div className="login-head">
          <h2>Enter your verification code</h2>
        </div>

        <form action="" onSubmit={handleVerify}>
          <div className="login-fields ">
            <React.Fragment>
              <div className="row mx-3">
                <TextField
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  name="code"
                  type="text"
                  variant="filled"
                  fullWidth
                  id="input-with-icon-textfield"
                  placeholder="Recovery Code *"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" className="mb-3">
                        <VpnKeyIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <div className="row mx-3 mb-2 regBtn">
                <Button
                  variant="contained"
                  className="btn-main"
                  disabled={loading}
                  type="submit"
                >
                  {loading ? (
                    <React.Fragment>
                      {" "}
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />{" "}
                      Redirecting{" "}
                    </React.Fragment>
                  ) : (
                    "Verify"
                  )}
                </Button>
              </div>
            </React.Fragment>
          </div>
        </form>
      </Dialog>
    </div>
  );
}
